<template>
    <div>
        <a class="btn-annotation btn-play-block"
           href="#"
           :style="data.styleRect"
           :id="`btn-play-block-${props.pagenum}-${props.annot.id}`"
           @click.prevent="startBlock"
        >
            <img :src="`${bookInfoState.publicPath}/${props.annot.iconSrc}`"
                 v-if="props.annot.iconSrc"
            >
        </a>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {updateFileNameIfMultipleSpeech} from  "@/modules/utils/pathUtils";
    import {replaceAudioPathForStagingServer} from  "@/modules/utils/pathUtils";
    import cssvar from '@/scss/_variables.scss';

    const colorRect = cssvar.colorRect;
    const {getResizedAnnotationPos, styleAnnotationBtn} = useAnnotationHelper();

    export default {

        props: {
          annot:Object,
          sharedMeta:Object,
          pagenum:Number
        },
        setup(props, context) {

            const { parserState } = useParser();
            const { bookInfoState, removeActiveAudioSrc} = useBookInfo();
            const { pageResizeState} = usePageResize();
            const { playBlockState, setBlockData, playBlocks} = usePlayBlockControl();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        ...styleAnnotationBtn(props.annot.hide)
                    }
                }),
                wordAudioData:computed(()=>{
                    return  props.sharedMeta[props.annot.grouptag]["wordAudioData"][bookInfoState.activeSpeech];
                }),
                formattedAudioSrcList:null
            });

            const startBlock = (e)=> {

                removeActiveAudioSrc();

                //if there is parameter, it should be triggered by the play block button, and the mode will be single page block mode:
                //Only remove block data if not multiple page mode, in which case, watchEffect hook will be watched and it'll set playBlockState.currentSpanIndex = 0,
                if (e && e.currentTarget) {
                    useKaraokeControl().reset();
                    usePlayBlockControl().reset();

                    //If there is aimPageBtnId, the target button will be triggered to play after the current blocks of audio completes.
                    //Stores the data and the watchEffect hook of the target button will be executed then.
                    if (props.annot.aimPageBtnId) {
                        playBlockState.multiBlockSpanStatus = {
                            aimPageBtnId: props.annot.aimPageBtnId,
                            aimPageIndex: props.annot.aimPageIndex,
                            isTargeted:false,
                            activePagenum: props.pagenum
                        }
                    }
                }

                data.formattedAudioSrcList = props.annot.audioSrcList.map(el => {
                    let path =  updateFileNameIfMultipleSpeech(`${bookInfoState.publicPath}/${el}`);
                    //if served on staging (.23), update url to make 206 response available...
                    return replaceAudioPathForStagingServer(path);
                })


                nextTick(()=> {
                    setBlockData(props.annot.id, props.pagenum, data.formattedAudioSrcList)
                    playBlocks();
                });

            }

            watchEffect(()=> {

                //Start multiple page block if the current button data match the target pointed by multi whole page button.
                //This should normally be directed from multi whole pages:
                if (playBlockState.multiWholePageStatus.multiPageTargetBtnId === props.annot.id &&
                    playBlockState.currentSpanIndex === -1 &&
                    playBlockState.multiWholePageStatus.multiPageTargetPageNum === props.pagenum
                ) {
                    //just set currentSpanIndex to start from the first span, without resetting other multiWholePageStatus data
                    playBlockState.currentSpanIndex = 0;
                    startBlock();
                //otherwise, should be watched if the current button is pointed by a span (multiSpanStatus.isTargeted will tell when the button has been targeted),
                //multiSpanStatus.isTargeted  will be reset to false after the assigned spans have finished and the audio will stop.
                } else if (playBlockState.multiSpanStatus.aimPageBtnId === props.annot.id &&
                           playBlockState.multiSpanStatus.aimPageIndex === props.pagenum &&
                           playBlockState.multiSpanStatus.isTargeted
                ) {
                        startBlock();
                }
                //otherwise, should be watched if the current button is pointed by another play block btn.
                //multiBlockSpanStatus.isTargeted will be reset to false after the assigned spans have finished and the audio will stop.
                else if (playBlockState.multiBlockSpanStatus.aimPageIndex === props.pagenum &&
                        playBlockState.multiBlockSpanStatus.aimPageBtnId === props.annot.id &&
                        playBlockState.multiBlockSpanStatus.isTargeted
                ) {
                    usePlayBlockControl().reset();
                    nextTick(()=> {
                        startBlock();
                    });
                }

            });


            onMounted(() => {

            });

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
                playBlockState,
                startBlock,
                setBlockData,
                playBlocks,
                getResizedAnnotationPos
            }

        }
    }

 </script>


<style scoped lang="scss">


</style>